import { render, staticRenderFns } from "./RemittanceList.vue?vue&type=template&id=cc304c68&scoped=true&"
import script from "./RemittanceList.vue?vue&type=script&lang=js&"
export * from "./RemittanceList.vue?vue&type=script&lang=js&"
import style0 from "./RemittanceList.vue?vue&type=style&index=0&id=cc304c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc304c68",
  null
  
)

export default component.exports